module.exports = __webpack_public_path__ + "static/media/8OLA9.8dc138e3.jpg";